import { cn } from "../../../utils/cn";

interface Props {
  text: string;
  variant: "primary" | "secondary" | "amber";
}

const LegendItem = ({ text, variant }: Props) => {
  return (
    <div
      className={cn(
        "px-2 py-2 border-l-8 rounded border-primary",
        variant === "primary" && "border-[#00875D]",
        variant === "secondary" && "border-secondary",
        variant === "amber" && "border-amber-500"
      )}
    >
      <span className="text-base font-medium text-secondary">{text}</span>
    </div>
  );
};

export default LegendItem;
